import { render } from "./ClientNote.vue?vue&type=template&id=4d726dd6"
import script from "./ClientNote.vue?vue&type=script&lang=js"
export * from "./ClientNote.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__